export default "__VITE_ASSET__DJlVHhTN__"